import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILookup } from '../common/interfaces/ILookup.interface';
import { HttpClient } from '@angular/common/http';
import { UrlPrefix } from "../common/constants/url-prefix.constants";
import { CpqSelectRequest } from './cpq-select.model';
import { HttpRequestType } from '../common/models/HttpRequestType.model';

@Injectable()

export class CpqSelectService {

    constructor(private http: HttpClient) { }

    public getLookups<TKey extends string | number>(url: string, query: string, id?: any): Observable<Array<ILookup<TKey, string>>> {
        let encodedQuery = encodeURIComponent(query);
        let requestUrl: string;
        if(id) {
            requestUrl = `${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}?query=${encodedQuery}&id=${id}`;
        } else {
            requestUrl = `${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}?query=${encodedQuery}`;
        }

        return this.http.get<Array<ILookup<TKey, string>>>(requestUrl);
    }

    public getLooukpsWithBody<TKey extends string | number>(request: CpqSelectRequest, query: string, id?: any) {
        let encodedQuery = encodeURIComponent(query);
        let requestUrl: string;
        if(id) {
            requestUrl = `${UrlPrefix.OLD_SETUP_API_PREFIX}/${request.url}?query=${encodedQuery}&id=${id}`;
        } else {
            requestUrl = `${UrlPrefix.OLD_SETUP_API_PREFIX}/${request.url}?query=${encodedQuery}`;
        }

        switch(request.requestType) {
            case HttpRequestType.GET:
                return this.http.get<Array<ILookup<TKey, string>>>(requestUrl);
            case HttpRequestType.POST:
                return this.http.post<Array<ILookup<TKey, string>>>(requestUrl, JSON.stringify(request.body));
            case HttpRequestType.PUT:
                return this.http.put<Array<ILookup<TKey, string>>>(requestUrl, JSON.stringify(request.body));
            case HttpRequestType.PATCH:
                return this.http.patch<Array<ILookup<TKey, string>>>(requestUrl, JSON.stringify(request.body));
            case HttpRequestType.DELETE:
                return this.http.delete<Array<ILookup<TKey, string>>>(requestUrl);
            default:
                throw Error('Unsupported HTTP Request type.');
        }
    }
}
